<template lang='pug'>
#footer
	.item.first Sápuboltinn
	//- .item kt: 401010-1010
	//- .item vsk. nr: 123456
	a.item(href='tel:+3548488452') Sími: 848-8452
	a.item(href='mailto:sapuboltinn@sapuboltinn.is') sapuboltinn@sapuboltinn.is
	.item
		img(src='@/assets/logo1.svg')
</template>

<script>
export default {
	name: 'Footer'
};
</script>

<style lang="less" scoped>
#footer {
	height: 100px;
	width: 100vw;
	background-color: #118acd;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	grid-gap: 20px;
	position: relative;
	@media screen and (max-width: 1300px) {
		grid-template-columns: 1fr;
		height: auto;
		padding-top: 50px;
		padding-bottom: 50px;
	}
	.item {
		text-align: center;
		color: #f6e0d6;
		font-size: 16px;
		text-decoration: none;
		@media screen and (min-width: 1301px) {
			line-height: 100px;
		}
		&.first {
			font-weight: bold;
		}
		img {
			@media screen and (min-width: 1301px) {
				position: relative;
				top: 21px;
			}
		}
	}
}
</style>
